"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    toolbarClassNames: ()=>toolbarClassNames,
    useToolbarStyles_unstable: ()=>useToolbarStyles_unstable
});
const _react = require("@griffel/react");
const toolbarClassNames = {
    root: 'fui-Toolbar'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react["__styles"])({
    root: {
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        z8tnut: "f10ra9hq",
        z189sj: [
            "f19lj068",
            "f177v4lu"
        ],
        Byoj8tv: "f1y2xyjm",
        uwmqm3: [
            "f177v4lu",
            "f19lj068"
        ],
        i8kkvl: "f4px1ci",
        Belr9w4: "fn67r4l"
    },
    vertical: {
        Beiy3e4: "f1vx9l62",
        a9b677: "f1acs6jw"
    },
    small: {
        Bqenvij: "f1d2rq10"
    },
    medium: {
        Bqenvij: "fbhnoac"
    },
    large: {
        Bqenvij: "ff2sm71"
    }
}, {
    d: [
        ".f22iagw{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}",
        ".f122n59{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}",
        ".f10ra9hq{padding-top:4px;}",
        ".f19lj068{padding-right:8px;}",
        ".f177v4lu{padding-left:8px;}",
        ".f1y2xyjm{padding-bottom:4px;}",
        ".f4px1ci{-webkit-column-gap:8px;column-gap:8px;}",
        ".fn67r4l{row-gap:8px;}",
        ".f1vx9l62{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}",
        ".f1acs6jw{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;}",
        ".f1d2rq10{height:32px;}",
        ".fbhnoac{height:40px;}",
        ".ff2sm71{height:48px;}"
    ]
});
const useToolbarStyles_unstable = (state)=>{
    const styles = useStyles();
    const { vertical , size  } = state;
    state.root.className = (0, _react.mergeClasses)(toolbarClassNames.root, styles.root, vertical && styles.vertical, size === 'small' && !vertical && styles.small, size === 'medium' && !vertical && styles.medium, size === 'large' && !vertical && styles.large, state.root.className);
    return state;
}; //# sourceMappingURL=useToolbarStyles.js.map

//# sourceMappingURL=useToolbarStyles.js.map